import { motion } from "framer-motion";
import { ArrowUpRight, XCircle, CheckCircle2 } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { useBooking } from "@/booking";

export const FinalCTA = () => {
  const openBooking = useBooking();

  return (
    <section data-testid="final-cta-section" className="relative overflow-hidden bg-night py-24 text-cream sm:py-32">
      <div aria-hidden className="pointer-events-none absolute -left-32 top-0 h-96 w-96 rounded-full bg-peach/15 blur-[120px]" />
      <div aria-hidden className="pointer-events-none absolute -bottom-24 -right-24 h-96 w-96 rounded-full bg-peach-dark/20 blur-[120px]" />

      <div className="relative mx-auto max-w-5xl px-5">
        <Reveal className="text-center">
          <Overline dark>The Decision</Overline>
          <h2 className="mt-5 font-display text-5xl uppercase leading-[0.95] tracking-wide sm:text-6xl lg:text-7xl">
            You Have Two Options
            <span className="mt-1 block font-body text-3xl font-semibold italic normal-case tracking-tight text-peach sm:text-4xl lg:text-5xl">
              Right Now.
            </span>
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-5 md:grid-cols-2">
          <Reveal>
            <div data-testid="option-a-card" className="h-full rounded-[2rem] border border-cream/10 p-8 sm:p-10">
              <XCircle size={26} className="text-cream/35" strokeWidth={1.6} />
              <h3 className="mt-5 font-heading text-lg font-bold text-cream/85">Option A</h3>
              <p className="mt-3 text-sm leading-relaxed text-cream/55 sm:text-base">
                You can close this page. And let things stay the way they are.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.12}>
            <div data-testid="option-b-card" className="h-full rounded-[2rem] border border-peach/40 bg-peach/10 p-8 sm:p-10">
              <CheckCircle2 size={26} className="text-peach" strokeWidth={1.6} />
              <h3 className="mt-5 font-heading text-lg font-bold text-cream">Option B</h3>
              <p className="mt-3 text-sm leading-relaxed text-cream/75 sm:text-base">
                Take the first step toward clarity, direction, and becoming who you're truly capable of becoming.
              </p>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.2} className="mt-14 text-center">
          <p className="mx-auto max-w-xl text-sm leading-relaxed text-cream/65 sm:text-base">
            You don't have to figure everything out on your own. Let's discuss your goals, challenges, and the next
            steps toward your personal and career growth.
          </p>
          <motion.button
            data-testid="final-cta-book-btn"
            onClick={openBooking}
            whileHover={{ y: -3 }}
            whileTap={{ scale: 0.97 }}
            className="group relative mt-9 inline-flex items-center gap-2.5 rounded-full bg-peach-dark px-9 py-5 font-heading text-sm font-bold text-cream shadow-[0_0_50px_-8px_rgba(246,146,137,0.65)] transition-colors duration-300 hover:bg-peach-deeper sm:text-base"
          >
            <span aria-hidden className="absolute inset-0 animate-ping rounded-full bg-peach-dark/30 [animation-duration:2.4s]" />
            <span className="relative">Book My Strategy Call — ₹199</span>
            <ArrowUpRight size={18} className="relative transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </motion.button>
          <p className="mt-5 font-heading text-[11px] font-semibold uppercase tracking-[0.22em] text-cream/40">
            Take the first step toward clarity and intentional growth
          </p>
        </Reveal>
      </div>
    </section>
  );
};
